module.exports = __webpack_public_path__ + "img/promotion-expired.71a1a082.svg";